import { ThemeEvents } from '@theme/events';

class SpecificationRow extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector('.specification-row-wrapper');
    this.updateRow = this.updateRow.bind(this);
  }

  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdate, this.updateRow);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateRow);
  }

  updateRow(event) {
    const newDoc = event.detail.data.html;
    const blockId = this.dataset.blockId;

    const newWrapper = newDoc.querySelector(
      `specification-row[data-block-id="${blockId}"] .specification-row-wrapper`
    );

    if (!this.wrapper || !newWrapper) return;

    this.wrapper.innerHTML = newWrapper.innerHTML;
  }
}

customElements.define('specification-row', SpecificationRow);
